import useFullUrl from "web/core/shop/useFullUrl";
import { stringify } from "web/core/utils/queryString";
import makeQueryFromLocation from "theme/modules/Layer/makeQueryFromLocation";

const useCanonicalCategoryUrl = (category, location) => {
  const queryHelper = makeQueryFromLocation(location);
  const existingFacets = category.layer.dynamicFacets.map(({ code }) => code);
  const queryString = stringify(
    queryHelper.filterCanonicalQueryStringParameters(existingFacets, false)
  );

  return useFullUrl(
    `${location.pathname}${queryString ? `?${queryString}` : ""}`
  );
};

export default useCanonicalCategoryUrl;
